import React from "react";
import { SummaryTabNames } from "../common/enums/club.enum";
import {
  IClubMember,
  IInvitationSolana,
} from "../common/interfaces/clubs.interface";
import { IBasicProposalData } from "../common/interfaces/proposals.interface";

interface IOverviewClubContext {
  members: IClubMember[] | undefined;
  setMembers: (clubMembersWithDetails: IClubMember[]) => void;
  splProposals: IBasicProposalData[] | undefined;
  setSplProposals: (proposal: IBasicProposalData[] | undefined) => void;
  invitations: IInvitationSolana[] | undefined;
  setInvitations: (invitations: IInvitationSolana[]) => void;
  activeStep: SummaryTabNames;
  setActiveStep: (step: SummaryTabNames) => void;
}

export const OverviewClubContext = React.createContext(
  {} as IOverviewClubContext
);
